import React, { useContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, IconButton, Link, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import _ from 'lodash';
import { useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router';
import { useOpenChipNotification } from '../../../utils/openChipNotification';
import { darken, makeStyles } from '@material-ui/core/styles';
import { yellow } from '@material-ui/core/colors';
import Comment from '../../../components/Comments/Comment';
import { TODO_TYPE } from '../../../constants/comments';
import { updateComment } from '../../../api/comments';
import { addCommentToMarket } from '../../../contexts/CommentsContext/commentsContextHelper';
import { CommentsContext } from '../../../contexts/CommentsContext/CommentsContext';
import { OperationInProgressContext } from '../../../contexts/OperationInProgressContext/OperationInProgressContext';
import {
  formMarketAddCommentLink,
  formMarketAddInvestibleLink, MARKET_TODOS_HASH,
  navigate
} from '../../../utils/marketIdPathFunctions';
import Chip from '@material-ui/core/Chip';
import { CheckCircleOutline } from '@material-ui/icons';
import {
  findMessageForCommentId, findMessagesForCommentIds,
  getPaginatedItems,
  getRealPage,
  getUnreadCount,
  removeMessagesForCommentId
} from '../../../utils/messageUtils';
import { NotificationsContext } from '../../../contexts/NotificationsContext/NotificationsContext';
import { getThreadIds, getThreads } from '../../../utils/commentFunctions';
import { SearchResultsContext } from '../../../contexts/SearchResultsContext/SearchResultsContext';
import DismissableText from '../../../components/Notifications/DismissableText';
import { deleteOrDehilightMessages } from '../../../api/users';
import { stripHTML } from '../../../utils/stringFunctions';
import { BLUE_LEVEL, RED_LEVEL, UNASSIGNED_TYPE, YELLOW_LEVEL } from '../../../constants/notifications';
import { BUG_WIZARD_TYPE } from '../../../constants/markets';
import { useInlineWizardLaunch } from '../../../components/InlineWizard/InlineWizardContext';
import BugListItem from '../../../components/Comments/BugListItem';
import getReducer, {
  contractAll,
  expandAll,
  PAGE_SIZE,
  pin,
  setPage,
  setTab
} from '../../../components/Comments/BugListContext';
import { getDeterminateReducer } from '../../../contexts/ContextUtils';
import { GmailTabItem, GmailTabs } from '../../../containers/Tab/Inbox';
import { Eject, ExpandLess, KeyboardArrowLeft } from '@material-ui/icons';
import TooltipIconButton from '../../../components/Buttons/TooltipIconButton';
import { useButtonColors } from '../../../components/Buttons/ButtonConstants';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { getNewBugNotifications } from '../../../components/Comments/Options';
import SpinningButton from '../../../components/SpinBlocking/SpinningButton';
import { wizardStyles } from '../../../components/AddNewWizards/WizardStylesContext';
import AddIcon from '@material-ui/icons/Add';
import {
  DEHIGHLIGHT_EVENT,
  DELETE_EVENT,
  MODIFY_NOTIFICATIONS_CHANNEL
} from '../../../contexts/NotificationsContext/notificationsContextMessages';
import { pushMessage } from '../../../utils/MessageBusUtils';
import { dehighlightCriticalMessage } from '../../../contexts/NotificationsContext/notificationsContextReducer';
import EditIcon from '@material-ui/icons/Edit';
import { hasBug } from '../../../components/AddNewWizards/Bug/BugDescriptionStep';
import { useHotkeys } from 'react-hotkeys-hook';

export const todoClasses = makeStyles(
  theme => {
    return {
      outlined: {
        cursor: 'grab',
        outline: `1px solid ${theme.palette.grey['400']}`,
        outlineOffset: '-5px',
        borderRadius: 16
      },
      outlinedSelected: {
        backgroundColor: theme.palette.grey['200'],
        outline: `1px solid ${theme.palette.grey['400']}`,
        outlineOffset: '-5px',
        borderRadius: 16
      },
      warnCard: {
        backgroundColor: yellow['100'],
        padding: theme.spacing(1, 0, 0, 2),
        overflowY: 'auto',
        overflowX: 'hidden',
        maxHeight: '275px'
      },
      card: {
        padding: theme.spacing(1, 0, 0, 2),
        overflowY: 'auto',
        overflowX: 'hidden',
        maxHeight: '275px'
      },
      cardSelected: {
        backgroundColor: theme.palette.grey['200'],
        padding: theme.spacing(1, 0, 0, 2),
        maxHeight: '275px'
      },
      raisedCardSelected: {
        backgroundColor: theme.palette.grey['200'],
      },
      warnHighlightedCard: {
        backgroundColor: yellow['100'],
      },
      white: {
        backgroundColor: 'white',
        padding: 0,
        margin: 0,
        overflowY: 'auto',
        maxHeight: '25rem'
      },
      containerGreen: {
        borderColor: 'green',
        borderStyle: 'dashed',
        borderWidth: '3px',
        borderRadius: 6
      },
      outerBorder: {
        marginBottom: '30px'
      },
      chipStyleWhite: {
        backgroundColor: 'white',
        border: '0.5px solid grey'
      },
      chipStyleRed: {
        padding: '4px',
        backgroundColor: '#E85757'
      },
      chipStyleYellow: {
        padding: '4px',
        backgroundColor: '#e6e969'
      },
      chipStyleBlue: {
        padding: '4px',
        backgroundColor: '#2F80ED'
      },
      grow: {
        padding: '30px',
        flexGrow: 1
      },
      containerEmpty: {},
      containerHidden: {
        display: 'none'
      },
      actionSecondary: {
        backgroundColor: "#2d9cdb",
        color: "white",
        textTransform: 'none',
        fontWeight: '700',
        marginRight: '1rem',
        "&:hover": {
          backgroundColor: darken("#2d9cdb", 0.04)
        },
        "&:focus": {
          backgroundColor: darken("#2d9cdb", 0.12)
        }
      },
    };
  },
  { name: 'Archive' }
);

function MarketTodos(props) {
  const {
    comments = [],
    resolvedTodoComments = [],
    marketId,
    groupId,
    isInArchives = false,
    sectionOpen, setSectionOpen,
    hidden,
    isInbox=false,
    openDefaultId,
    message,
    activeInvestibles,
    isSupport = false
  } = props
  const classes = todoClasses();
  const wizardClasses = wizardStyles();
  const { openInlineWizard } = useInlineWizardLaunch();
  const intl = useIntl();
  const history = useHistory();
  const openChipNotification = useOpenChipNotification();
  const theme = useTheme();
  const location = useLocation();
  const { hash } = location;
  const mobileLayout = useMediaQuery(theme.breakpoints.down('sm'));
  const { actionButtonColor, warningColor } = useButtonColors();
  const [commentState, commentDispatch] = useContext(CommentsContext);
  const [, setOperationRunning] = useContext(OperationInProgressContext);
  const [messagesState, messagesDispatch] = useContext(NotificationsContext);
  const [searchResults] = useContext(SearchResultsContext);
  const useOpenDefaultId = message?.is_highlighted ? openDefaultId : undefined;
  const reducerInitState = {page: 1, tabIndex: 0,
    expansionState: useOpenDefaultId ? {[useOpenDefaultId]: true} : {}, pageState: {}, defaultPage: 1};
  const [bugState, bugDispatch] = useReducer(getReducer(), reducerInitState);
  const [determinateState, determinateDispatch] = useReducer(getDeterminateReducer(),
    {determinate: {}, indeterminate: false, checkAll: false});
  const { indeterminate, determinate, checkAll } = determinateState;
  const { tabIndex, page: originalPage, expansionState, pinned } = bugState;
  const { results, parentResults, search } = searchResults;
  const todoComments = comments.filter(comment => {
    if (_.isEmpty(search)) {
      return comment.comment_type === TODO_TYPE;
    }
    return comment.comment_type === TODO_TYPE && (results.find((item) => item.id === comment.id)
      || parentResults.find((id) => id === comment.id));
  }) || [];
  const resolvedRoots = (resolvedTodoComments || []).filter((comment) => comment.comment_type === TODO_TYPE);
  const resolvedComments = resolvedRoots.filter((comment) => {
    if (_.isEmpty(search)) {
      return true;
    }
    return results.find((item) => item.id === comment.id)
      || parentResults.find((id) => id === comment.id);
  });
  const isSearchActive = !_.isEmpty(search);
  const blueComments = todoComments.filter((comment) => comment.notification_type === BLUE_LEVEL);
  const yellowComments = todoComments.filter((comment) => comment.notification_type === YELLOW_LEVEL);
  const redComments = todoComments.filter((comment) => comment.notification_type === RED_LEVEL);
  // During search collapse sub-tabs: show all open bugs combined; resolved only contributes to parent count
  const tabCommentsRaw = isSearchActive
    ? [...redComments, ...yellowComments, ...blueComments]
    : (tabIndex === 0 ? redComments
        : (tabIndex === 1 ? yellowComments
          : (tabIndex === 2 ? blueComments : resolvedComments)));
  const isResolvedTab = !isSearchActive && tabIndex === 3;
  const commentsForCurrentTab = isResolvedTab ? resolvedTodoComments : comments;
  // S-all-199: badge unread replies at any depth too - only the counts fold threads in,
  // the row lists stay roots
  const redThreads = getThreads(redComments, comments);
  const yellowThreads = getThreads(yellowComments, comments);
  const blueThreads = getThreads(blueComments, comments);
  const unreadRedCount = getUnreadCount(redThreads, messagesState.messages);
  const unreadYellowCount = getUnreadCount(yellowThreads, messagesState.messages);
  const unreadBlueCount = getUnreadCount(blueThreads, messagesState.messages);
  function highlightedFor(commentList) {
    return findMessagesForCommentIds((commentList || []).map((comment) => comment.id), messagesState.messages, true);
  }
  const redNewMessages = highlightedFor(redThreads);
  const yellowNewMessages = highlightedFor(yellowThreads);
  const blueNewMessages = highlightedFor(blueThreads);
  const resolvedNewMessages = highlightedFor(resolvedTodoComments);
  // resolvedTodoComments bundles resolved bug roots AND their replies, so this counts unread notifications
  // on either - including a reply that raced ahead of the bug being resolved (T-all-2237).
  const unreadResolvedCount = getUnreadCount(resolvedTodoComments, messagesState.messages);
  const tabComments = _.orderBy(tabCommentsRaw,
    [(comment) => _.size(findMessagesForCommentIds([comment.id], messagesState.messages, true)),
      'updated_at'], ['desc', 'desc']);
  const page = getRealPage(tabComments, pinned, originalPage, PAGE_SIZE);
  const { first, last, data, hasMore, hasLess } = getPaginatedItems(tabComments, page,
    PAGE_SIZE);

  useHotkeys('ctrl+a', () => openInlineWizard
      ? openInlineWizard({ wizardType: BUG_WIZARD_TYPE, marketId, groupId, commentType: tabIndex })
      : navigate(history, formMarketAddCommentLink(BUG_WIZARD_TYPE, marketId, groupId, tabIndex)),
    {enabled: !hidden && sectionOpen},
    [history, groupId, marketId, tabIndex, openInlineWizard]);

  useEffect(() => {
    if (hash && !hidden && !isInbox) {
      const todoParents = comments.filter(comment => comment.comment_type === TODO_TYPE &&
        !comment.investible_id && !comment.resolved) || [];
      const todoCommentIds = getThreadIds(todoParents, comments);
      let foundCommentId = todoCommentIds.find((anId) => hash.includes(anId));
      let searchComments = comments;
      if (!foundCommentId) {
        const resolvedParents = (resolvedTodoComments || []).filter((comment) =>
          comment.comment_type === TODO_TYPE);
        const resolvedCommentIds = getThreadIds(resolvedParents, resolvedTodoComments || []);
        foundCommentId = resolvedCommentIds.find((anId) => hash.includes(anId));
        searchComments = resolvedTodoComments || [];
      }
      if (foundCommentId) {
        const foundComment = searchComments.find((comment) => comment.id === foundCommentId);
        const { root_comment_id: rootId } = foundComment;
        const rootComment = !rootId ? foundComment : searchComments.find((comment) => comment.id === rootId);
        if (rootComment) {
          const { notification_type: notificationType, resolved } = rootComment;
          const targetTab = resolved ? 3 : (notificationType === RED_LEVEL ? 0 :
            (notificationType === YELLOW_LEVEL ? 1 : 2));
          if (tabIndex !== targetTab) bugDispatch(setTab(targetTab));
          if (tabIndex !== targetTab || pinned !== rootComment.id || !expansionState[rootComment.id]) {
            bugDispatch(pin(rootComment.id));
          }
          const message = findMessageForCommentId(rootComment.id, messagesState.messages);
          if (message?.is_highlighted && !location.state?.searchMatch) {
            let event = DEHIGHLIGHT_EVENT;
            if (message.type_object_id.startsWith('UNREAD')) {
              event = DELETE_EVENT;
            }
            pushMessage(MODIFY_NOTIFICATIONS_CHANNEL, { event, message: message.type_object_id });
          }
          // ScrollContext consumes the object anchor after scrolling and highlighting it.
        }
      }
      if (foundCommentId || hash.includes(MARKET_TODOS_HASH)) {
        if (!sectionOpen) {
          setSectionOpen();
        }
      }
    }
    return () => {};
  }, [comments, resolvedTodoComments, hash, hidden, history, messagesState, sectionOpen, setSectionOpen, isInbox,
    tabIndex, pinned, expansionState, location.state?.searchMatch]);

  useEffect(() => {
    if (openDefaultId && message?.type === UNASSIGNED_TYPE) {
      messagesDispatch(dehighlightCriticalMessage(message.type_object_id,
        `${message.type}_${openDefaultId}`));
    }
  }, [message?.type, message?.type_object_id, messagesDispatch, openDefaultId]);

  function processTabNotifications() {
    const allMessages = [];
    data.forEach((comment) => {
      const replies = comments.filter(aComment => aComment.root_comment_id === comment.id &&
        aComment.id !== comment.id) || [];
      const myMessage = findMessageForCommentId(comment.id, messagesState.messages);
      if (myMessage) {
        allMessages.push(myMessage);
      }
      replies.forEach((reply) => {
        const aMessage = findMessageForCommentId(reply.id, messagesState.messages);
        if (aMessage) {
          allMessages.push(aMessage);
        }
      })
    })
    if (_.isEmpty(allMessages)) {
      setOperationRunning(false);
      return;
    }
    return deleteOrDehilightMessages(allMessages, messagesDispatch,true)
      .then(() => setOperationRunning(false))
      .finally(() => {
        setOperationRunning(false);
      });
  }

  function getRows() {
    if (_.isEmpty(data)) {
      return <div className={classes.grow} key={`todos${tabIndex}empty`}/>
    }
    const numOpen = _.size(data.filter((comment) => !!expansionState[comment.id]));
    return data.map((comment) => {
      const { id, body, updated_at: updatedAt, notification_type: notificationType, resolved } = comment;
      const replies = commentsForCurrentTab.filter(aComment => aComment.root_comment_id === id &&
        aComment.id !== id) || [];
      const expansionPanel = <div id={`c${id}`} key={`c${id}key`} style={{marginBottom: '1rem'}}>
        <Comment
          marketId={marketId}
          comment={comment}
          comments={commentsForCurrentTab}
          allowedTypes={[TODO_TYPE]}
          noAuthor
          isInbox={isInbox}
          inboxMessageId={id}
          focusMove={numOpen === 1}
        />
      </div>
      const determinateChecked = determinate[id];
      const checked = determinateChecked !== undefined ? determinateChecked : checkAll;
      return (
        <BugListItem id={id} key={id} replyNum={replies.length + 1} title={stripHTML(body)}
                     newMessages={getNewBugNotifications(comment, messagesState, replies)}
                     date={intl.formatDate(updatedAt)} marketId={marketId} groupId={groupId}
                     useSelect={!isInArchives} expansionPanel={expansionPanel} checked={checked}
                     expansionOpen={!!expansionState[id]} determinateDispatch={determinateDispatch}
                     bugListDispatch={bugDispatch} notificationType={notificationType}
                     isResolved={!!resolved}
                     activeInvestibles={activeInvestibles}/>
      );
    });
  }

  function onDrop(event, notificationType) {
    const commentId = event.dataTransfer.getData('text');
    const currentNotificationType = event.dataTransfer.getData("notificationType");
    const wasResolved = event.dataTransfer.getData('resolved') === 'true';
    if (currentNotificationType === notificationType && !wasResolved) {
      return Promise.resolve(false);
    }
    setOperationRunning(true);
    removeMessagesForCommentId(commentId, messagesState);
    const target = event.target;
    target.style.cursor = 'wait';
    const updateValues = { marketId, commentId, notificationType };
    if (wasResolved) {
      updateValues.resolved = false;
    }
    return updateComment(updateValues)
      .then((comment) => {
        addCommentToMarket(comment, commentState, commentDispatch);
        setOperationRunning(false);
        return comment;
      }).finally(() => {
      target.style.cursor = 'pointer';
      setOperationRunning(false);
    });
  }

  function onDropImmediate(event) {
    onDrop(event, 'RED');
  }

  function onDropAble(event) {
    onDrop(event, 'YELLOW');
  }

  function onDropConvenient(event) {
    onDrop(event, 'BLUE');
  }

  function onDropResolve(event) {
    const commentId = event.dataTransfer.getData('text');
    const wasResolved = event.dataTransfer.getData('resolved') === 'true';
    if (wasResolved) {
      return Promise.resolve(false);
    }
    setOperationRunning(true);
    removeMessagesForCommentId(commentId, messagesState);
    const target = event.target;
    target.style.cursor = 'wait';
    return updateComment({ marketId, commentId, resolved: true })
      .then((comment) => {
        addCommentToMarket(comment, commentState, commentDispatch);
        setOperationRunning(false);
        return comment;
      }).finally(() => {
        target.style.cursor = 'pointer';
        setOperationRunning(false);
      });
  }

  function changePage(byNum) {
    bugDispatch(setPage(page + byNum));
  }

  function moveSelected() {
    const selected = Object.keys(determinate).filter((key) => determinate[key]);
    const checked = checkAll ? data.filter((comment) => determinate[comment.id] !== false)
        .map((comment) => comment.id) : selected;
    let checkedString;
    if (!_.isEmpty(checked)) {
      checked.forEach((anId) => {
        if (checkedString) {
          checkedString += `&fromCommentId=${anId}`;
        } else {
          checkedString = `&fromCommentId=${anId}`;
        }
      });
      determinateDispatch({type: 'clear'});
      if (checkedString) {
        if (message) {
          navigate(history, `${formMarketAddInvestibleLink(marketId, groupId, undefined, 
            message.type_object_id)}${checkedString}`);
        } else {
          navigate(history, `${formMarketAddInvestibleLink(marketId, groupId)}${checkedString}`);
        }
      }
    }
  }

  const immediateTodosChip = <Chip color="primary" size='small' className={classes.chipStyleRed} />;
  const yellowChip = <Chip color="primary" size='small' className={classes.chipStyleYellow} />;
  const blueChip = <Chip color="primary" size='small' className={classes.chipStyleBlue} />;

  function doExpandAll(){
    bugDispatch(expandAll(data));
    processTabNotifications();
  }

  useHotkeys('ctrl+alt+e', doExpandAll, {enableOnContentEditable: true}, [data, expansionState]);
  useHotkeys('ctrl+shift+e', ()=> bugDispatch(contractAll(data)),
    {enableOnContentEditable: true}, [data, expansionState]);

  if (hidden) {
    return <React.Fragment/>;
  }

  return (
    <div id="marketTodos" key="marketTodosKey" style={{display: sectionOpen ? 'block' : 'none',
      overflowX: 'hidden', paddingBottom: !(isInbox || isInArchives) ? '5rem' : undefined}}>
      {!isInArchives && !isInbox && (
        <SpinningButton id="newMarketTodo"
                        className={wizardClasses.actionNext}
                        style={{marginBottom: '1rem', marginTop: '1rem'}}
                        variant="text" doSpin={false}
                        icon={hasBug(groupId) ? EditIcon : AddIcon} iconColor="black" toolTipId='hotKeyTODO'
                        onClick={() => openInlineWizard
                          ? openInlineWizard({ wizardType: BUG_WIZARD_TYPE, marketId, groupId, commentType: tabIndex })
                          : navigate(history, formMarketAddCommentLink(BUG_WIZARD_TYPE, marketId, groupId, tabIndex))}>
          {intl.formatMessage({ id: 'createBug'})}
        </SpinningButton>
      )}
      <DismissableText textId="todosHelp" isLeft noPad display={!isInArchives && _.isEmpty(search) && _.isEmpty(todoComments)}
                       text={
          isSupport ?
          <div>
            Open a bug and Uclusion support will respond. 
          </div>
          :
        <div>
          Use "Add bug" above to create a <Link href="https://documentation.uclusion.com/views/bugs" target="_blank">bug</Link> that
          sends notifications based on severity.
        </div>
      }/>
      {!isInbox && !isSearchActive && (
        <GmailTabs
          value={tabIndex}
          onChange={(event, value) => {
            bugDispatch(setTab(value));
          }}
          indicatorColors={[warningColor, '#e6e969', '#2F80ED', '#bdbdbd']}
          style={{ paddingBottom: '1rem', paddingTop: '1rem' }}>
          <GmailTabItem icon={immediateTodosChip} label={intl.formatMessage({id: 'immediate'})}
                        color='black' onTagClick={unreadRedCount > 0 ? () => openChipNotification(redNewMessages) : undefined}
                        tagLabel={unreadRedCount > 0 ? intl.formatMessage({id: 'new'}) : undefined}
                        tagColor={unreadRedCount > 0 ? warningColor : undefined}
                        tag={unreadRedCount > 0 ? `${unreadRedCount}` :
                          (_.size(redComments) > 0 ? `${_.size(redComments)}` : undefined)}
                        onDrop={onDropImmediate} toolTipId='immediateToolTip'
                        onDragOver={(event)=>event.preventDefault()}/>
          <GmailTabItem icon={yellowChip} label={intl.formatMessage({id: 'able'})}
                        color='black' onTagClick={unreadYellowCount > 0 ? () => openChipNotification(yellowNewMessages) : undefined}
                        tagColor={unreadYellowCount > 0 ? warningColor : undefined}
                        tagLabel={unreadYellowCount > 0 ? intl.formatMessage({id: 'new'}) : undefined}
                        tag={unreadYellowCount > 0 ? `${unreadYellowCount}` :
                          (_.size(yellowComments) > 0 ? `${_.size(yellowComments)}` : undefined)}
                        onDrop={onDropAble} toolTipId='normalToolTip'
                        onDragOver={(event)=>event.preventDefault()} />
          <GmailTabItem icon={blueChip} label={intl.formatMessage({id: 'convenient'})}
                        color='black' onTagClick={unreadBlueCount > 0 ? () => openChipNotification(blueNewMessages) : undefined}
                        tagColor={unreadBlueCount > 0 ? warningColor : undefined}
                        tagLabel={unreadBlueCount > 0 ? intl.formatMessage({id: 'new'}) : undefined}
                        tag={unreadBlueCount > 0 ? `${unreadBlueCount}` :
                          (_.size(blueComments) > 0 ? `${_.size(blueComments)}` : undefined)}
                        onDrop={onDropConvenient} toolTipId='minorToolTip'
                        onDragOver={(event)=>event.preventDefault()} />
          <GmailTabItem icon={<CheckCircleOutline />} label={intl.formatMessage({id: 'resolvedBugsHeader'})}
                        color='black' onTagClick={unreadResolvedCount > 0 ? () => openChipNotification(resolvedNewMessages) : undefined}
                        tagColor={unreadResolvedCount > 0 ? warningColor : undefined}
                        tagLabel={unreadResolvedCount > 0 ? intl.formatMessage({id: 'new'}) : undefined}
                        tag={unreadResolvedCount > 0 ? `${unreadResolvedCount}` : undefined}
                        onDrop={onDropResolve} toolTipId='resolvedToolTip'
                        onDragOver={(event)=>event.preventDefault()} />
        </GmailTabs>
      )}
      {!_.isEmpty(tabComments) && (
        <div key="todoComments" style={{paddingBottom: '0.25rem'}}>
          <div style={{display: 'flex', width: '80%'}}>
            {!mobileLayout && !isInArchives && (
              <Checkbox style={{padding: 0, marginLeft: '0.6rem'}}
                        checked={checkAll}
                        indeterminate={indeterminate}
                        onChange={() => determinateDispatch({type: 'toggle'})}
              />
            )}
            {(checkAll || !_.isEmpty(determinate)) && (
              <TooltipIconButton
                icon={<Eject htmlColor={actionButtonColor} />}
                onClick={moveSelected} translationId="todosCreateStory" />
            )}
            <TooltipIconButton icon={<ExpandLess style={{marginLeft: '0.25rem'}} htmlColor={actionButtonColor} />}
                               onClick={() => {
                                 bugDispatch(contractAll(data));
                               }} translationId="inboxCollapseAll" />
            <TooltipIconButton icon={<ExpandMoreIcon style={{marginLeft: '0.25rem'}} htmlColor={actionButtonColor} />}
                               onClick={doExpandAll} translationId="inboxExpandAll" />
            <div style={{flexGrow: 1}}/>
            <Box fontSize={14} color="text.secondary">
              {first} - {last} of {_.size(tabComments)}
              <IconButton disabled={!hasLess} onClick={() => changePage(-1)} >
                <KeyboardArrowLeft />
              </IconButton>
              <IconButton disabled={!hasMore} onClick={() => changePage(1)}>
                <KeyboardArrowRight />
              </IconButton>
            </Box>
          </div>
        </div>
      )}
      {_.isEmpty(data) && !isSearchActive && tabIndex === 0 && (
        <Typography style={{marginTop: '2rem', maxWidth: '40rem', marginLeft: 'auto', marginRight: 'auto'}}
                    variant="body1">
          {intl.formatMessage({id: 'immediate'})} is empty.<br/><br/>
          Bugs that urgently need assignment display here.
        </Typography>
      )}
      {_.isEmpty(data) && !isSearchActive && tabIndex === 1 && (
        <Typography style={{marginTop: '2rem', maxWidth: '40rem', marginLeft: 'auto', marginRight: 'auto'}}
                    variant="body1">
          {intl.formatMessage({id: 'able'})} is empty.<br/><br/>
          Bugs that need assignment display here.
        </Typography>
      )}
      {_.isEmpty(data) && !isSearchActive && tabIndex === 2 && (
        <Typography style={{marginTop: '2rem', maxWidth: '40rem', marginLeft: 'auto', marginRight: 'auto'}}
                    variant="body1">
          {intl.formatMessage({id: 'convenient'})} is empty.<br/><br/>
          Bugs that can wait till other work is done display here.
        </Typography>
      )}
      {_.isEmpty(data) && !isSearchActive && tabIndex === 3 && (
        <Typography style={{marginTop: '2rem', maxWidth: '40rem', marginLeft: 'auto', marginRight: 'auto'}}
                    variant="body1">
          {intl.formatMessage({id: 'resolvedBugsHeader'})} is empty.<br/><br/>
          Resolved bugs display here. Drag a bug to a severity tab to unresolve.
        </Typography>
      )}
      {getRows()}
    </div>
  )
}

MarketTodos.propTypes = {
  comments: PropTypes.arrayOf(PropTypes.object),
  marketId: PropTypes.string.isRequired,
};

export default MarketTodos;
